import React from "react";
import "./AppTable.css";

/// Long text for a table cell: capped width, clamped to `lines` lines, full
/// text on hover. `sub` adds a muted secondary line (e.g. a translation).
const TableText = ({ text, sub, maxWidth = 320, lines = 2 }) => {
  if (!text && !sub) return <span className="text-soft">-</span>;
  return (
    <div className="app-table-text" style={{ maxWidth }}>
      <span
        className="app-table-text__main"
        style={{ WebkitLineClamp: lines }}
        title={text}
      >
        {text || "-"}
      </span>
      {sub && (
        <span className="app-table-text__sub" title={sub}>
          {sub}
        </span>
      )}
    </div>
  );
};

export default TableText;
